import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { NIKE_URL } from "@/data/constants/url";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useLang } from "@/hooks/use-lang";
import { Lang } from "@/i18n-config";

type TradingViewIndexParams = {
  token: string;
  tradingviewAccount: string;
  lang: Lang;
};

export const addTradingViewAccount = async ({
  token,
  tradingviewAccount,
  lang,
}: TradingViewIndexParams) => {
  if (!token || !tradingviewAccount) throw new Error("missing params");

  const endpoint = "/tradingview/account";
  const res = await fetch(`${NIKE_URL}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-User-Profile": token,
      "Accept-Language": lang,
    },
    body: JSON.stringify({ tradingviewAccount }),
  });
  if (!res.ok) throw new Error(`API failed (${endpoint})`);
  return await res.json();
};

export const useAddTradingViewIndex = () => {
  const queryClient = useQueryClient();
  const { lang, t } = useLang();
  const { backendToken: token } = useAuth();
  return useMutation(
    (params: Pick<TradingViewIndexParams, "tradingviewAccount">) =>
      addTradingViewAccount({ ...params, token: token ?? "", lang }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["trading-view-account", token, lang]);
        toast.success(t.analysis.trend.tradingViewIndex.successMsg);
      },
      onError: () => {
        toast.error(t.analysis.trend.tradingViewIndex.errorMsg);
      },
    }
  );
};
